import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

const useStyles = makeStyles(theme => (({
  dialogContent: {
    lineHeight: 1.5,
    fontSize: theme.spacing(2),
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: '#111827',
    textAlign: 'center',
    marginBottom: 12,
    marginTop: 10,
  },
  description: {
    color: '#6B7280',
    textAlign: 'center',
    marginBottom: 24,
    lineHeight: 1.5,
    fontSize: 14,
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
})));

export interface CancelOrderDialogProps {
  showDialog: boolean,
  handleCancelOrder: () => void,
  handleCloseDialog: () => void,
}

const CancelOrderDialog = (props: CancelOrderDialogProps) => {
  const classes = useStyles();
  const {
    showDialog,
    handleCancelOrder,
    handleCloseDialog,
  } = props;

  return (
    <Dialog
      open={showDialog}
      id="cancel-order-dialog"
      onClose={handleCloseDialog}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          paddingX: 2,
          borderRadius: 1.5,
          maxWidth: 410,
        },
      }}
    >
      <DialogContent id="cancel-order-dialog-content" className={classes.dialogContent}>
        <p className={classes.title}>
          <FormattedMessage
            id="page.order.history.cancel.order.title"
          />
        </p>
        <p className={classes.description}>
          <FormattedMessage
            id="page.order.history.cancel.order.message"
          />
        </p>
        <div className={classes.btnContainer}>
          <Button
            id="keep-order-btn"
            onClick={handleCloseDialog}
            sx={theme => ({
              height: theme.spacing(5),
              color: '#6B7280',
              '&:hover': {
                backgroundColor: '#F9FAFB',
              },
              padding: '0px 20px',
              border: '1px solid #E5E7EB',
              borderRadius: 2,
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
              textDecoration: 'none',
              display: 'inline-block',
            })}
          >
            <FormattedMessage
              id="page.order.history.cancel.order.keep"
            />
          </Button>
          <Button
            id="cancel-order-btn"
            onClick={handleCancelOrder}
            sx={theme => ({
              height: theme.spacing(5),
              color: '#DC2626',
              '&:hover': {
                backgroundColor: '#FEE2E2',
              },
              padding: '0px 20px',
              border: '1px solid #FEE2E2',
              borderRadius: 2,
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
              textDecoration: 'none',
              display: 'inline-block',
              marginLeft: 2,
            })}
          >
            <FormattedMessage
              id="page.order.history.cancel.order.cancel"
            />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CancelOrderDialog;
